/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
function initAnchorHighlight() {
  var $buttons = $('.desk_product-anchor-button[data-target]');
  if (!$buttons.length) return;

  var anchors = [];
  $buttons.each(function () {
    var $btn = $(this);
    $('[data-id="' + $btn.data('target') + '"]').each(function () {
      anchors.push({ $button: $btn, $section: $(this) });
    });
  });

  if (!anchors.length) return;

  anchors.sort(function (a, b) {
    return a.$section.offset().top - b.$section.offset().top;
  });

  var $anchorBox = $('.desk_product-anchor-outer_box');
  var $anchorScroll = $('.desk_product-anchor-outer');
  var isScrollingToTarget = false;
  var scrollingTimer = null;
  var currentActiveBtn = null;
  var centerRafId = null;
  var centerDebounceTimer = null;

  function getThreshold() {
    return window.innerHeight * 0.7;
  }

  function getPageScrollTarget($section) {
    var $anchorPlaceholder = $('.desk_product-anchor-outer_box__placeholder');
    var anchorHeight = $anchorPlaceholder.length ? $anchorPlaceholder.outerHeight() : 0;
    var headerTop = $anchorBox.hasClass('anchor-sticking') ? ($anchorBox[0].getBoundingClientRect().top || 56) : 0;
    return $section.offset().top - headerTop - anchorHeight;
  }

  function easeInOut(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }

  function centerActiveButton($btn) {
    if (!$anchorScroll.length || !$btn || !$btn.length) return;
    if (centerRafId) cancelAnimationFrame(centerRafId);

    var el = $anchorScroll[0];
    var targetLeft = $btn[0].offsetLeft - (el.offsetWidth / 2) + ($btn[0].offsetWidth / 2);
    var startLeft = el.scrollLeft;
    var startTime = null;
    var duration = 350;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      el.scrollLeft = startLeft + (targetLeft - startLeft) * easeInOut(progress);
      if (progress < 1) {
        centerRafId = requestAnimationFrame(step);
      } else {
        centerRafId = null;
      }
    }

    centerRafId = requestAnimationFrame(step);
  }

  function setActive($btn, immediate) {
    if (currentActiveBtn && currentActiveBtn[0] === $btn[0]) return;
    $buttons.removeClass('active');
    $btn.addClass('active');
    currentActiveBtn = $btn;

    clearTimeout(centerDebounceTimer);
    if (immediate) {
      centerActiveButton($btn);
    } else {
      var $captured = $btn;
      centerDebounceTimer = setTimeout(function () {
        if (currentActiveBtn && currentActiveBtn[0] === $captured[0]) {
          centerActiveButton($captured);
        }
      }, 250);
    }
  }

  function clearActive() {
    if (!currentActiveBtn) return;
    $buttons.removeClass('active');
    currentActiveBtn = null;
    clearTimeout(centerDebounceTimer);
  }

  function update() {
    if (isScrollingToTarget) return;

    var threshold = getThreshold();
    var lastBottom = anchors[anchors.length - 1].$section[0].getBoundingClientRect().bottom;

    if (lastBottom < 0) {
      clearActive();
      return;
    }

    var active = null;
    $.each(anchors, function (i, item) {
      if (item.$section[0].getBoundingClientRect().top <= threshold) active = item;
    });

    if (active) {
      setActive(active.$button, false);
    } else {
      clearActive();
    }
  }

  $buttons.on('click', function () {
    var $clicked = $(this);
    var target = $clicked.data('target');
    var match = null;
    $.each(anchors, function (i, item) {
      if (item.$button.data('target') === target) { match = item; return false; }
    });
    if (!match) return;

    setActive($clicked, true);
    isScrollingToTarget = true;

    clearTimeout(scrollingTimer);
    scrollingTimer = setTimeout(function () {
      isScrollingToTarget = false;
    }, 2000);

    var scrollTo = getPageScrollTarget(match.$section);

    if (window.lenis) {
      window.lenis.scrollTo(scrollTo, {
        duration: 1,
        onComplete: function () {
          clearTimeout(scrollingTimer);
          isScrollingToTarget = false;
        }
      });
    } else {
      $('html, body').animate({ scrollTop: scrollTo }, 500, function () {
        clearTimeout(scrollingTimer);
        isScrollingToTarget = false;
      });
    }
  });

  $(window).on('scroll.anchorHighlight', update);
  update();
}

$(document).ready(initAnchorHighlight);
